"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTempAttach = void 0;
var regexps_1 = require("./regexps");
var isTempAttach = function (messageId, temporaryMessageIdReg) {
    if (temporaryMessageIdReg === void 0) { temporaryMessageIdReg = regexps_1.defaultRegExps.messageIdsRegExps.temporaryMessageIdReg; }
    return !!messageId.match(new RegExp(temporaryMessageIdReg));
};
exports.isTempAttach = isTempAttach;
//# sourceMappingURL=isTempAttach.js.map